import type { Location } from 'history';
import { isExternalPath, isReactPath } from './routing';
import captureException from './captureException';

/**
 * Extracts the return url encoded in the query params.
 * Defaults to the home page if there is no valid `return` param.
 */
const getReturnUrl = (location: Pick<Location, 'search'>): string => {
  // Use URLSearchParams only, which handles both decoding and multiple values
  const params = new URLSearchParams(location.search);
  const target = params.get('return');

  if (!target) {
    return '/';
  }

  // Validate the URL
  if (isReactPath(target) || isExternalPath(target)) {
    return target;
  }

  if (target !== '/') {
    // Report any url redirects that have not been processed, as these are likely suspicious.
    captureException(new Error('Invalid return url'), {
      extra: {
        target,
      },
    });
  }

  // Default to the home page
  return '/';
};

export default getReturnUrl;
